<!-- @format -->

<template>
  <el-dialog :title="$t('listOwner.buttons.edit')" :visible.sync="visible" width="800px" @close="resetForm">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('listOwner.columns.type')" prop="personType">
            <el-select v-model="form.personType" style="width: 100%">
              <el-option v-for="(type, index) in personTypes" :key="index" :label="type.label" :value="type.value" />
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('listOwner.columns.role')" prop="personRole">
            <el-select v-model="form.personRole" style="width: 100%">
              <el-option v-for="role in personRoles" :key="role.value" :label="role.label" :value="role.value" />
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('listOwner.columns.name')" prop="name">
            <el-input v-model="form.name" :placeholder="$t('listOwner.placeholders.name')" />
          </el-form-item>

          <el-form-item v-if="form.personType === 'C'" :label="$t('listOwner.buttons.member')">
            <el-input v-model="form.concactPerson" />
          </el-form-item>

          <el-form-item :label="$t('listOwner.columns.phone')" prop="link">
            <el-input v-model="form.link" :placeholder="$t('listOwner.placeholders.phone')" />
          </el-form-item>

          <el-form-item v-if="form.personType === 'P'" :label="$t('listOwner.columns.gender')" prop="sex">
            <el-select v-model="form.sex" style="width: 100%">
              <el-option v-for="gender in genders" :key="gender.value" :label="gender.label" :value="gender.value" />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12" class="text-center">
          <div class="avatar-uploader" v-if="form.ownerPhotoUrl == '' && hasCamera">
            <!-- 摄像头预览 -->
            <video ref="video" autoplay playsinline width="320" height="160"></video>
            <!-- 拍下来的照片预览 -->
            <canvas ref="canvas" style="display: none"></canvas>
          </div>
          <div class="avatar-uploader" v-else>
            <el-image v-if="form.ownerPhotoUrl" style="width: 200px; height: 150px; border: 1px dashed #ccc" :src="form.ownerPhotoUrl" fit="cover" />
            <el-image v-else style="width: 200px; height: 150px; border: 1px dashed #ccc" src="/img/noPhoto.jpg" fit="cover" />
          </div>
          <div style="display: flex; justify-content: center">
            <el-button type="primary" icon="el-icon-camera" style="margin-right: 10px" @click="takePhoto" v-if="hasCamera">
              {{ $t("addOwnerMember.takePhoto") }}
            </el-button>
            <el-upload :show-file-list="false" :before-upload="beforeUpload" :http-request="uploadImage" action="">
              <el-button type="primary">
                {{ $t("editOwnerMember.uploadPhoto") }}
              </el-button>
            </el-upload>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('listOwner.columns.backupPhone')">
            <el-input v-model="form.concactLink" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('listOwner.columns.address')">
            <el-input v-model="form.address" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item v-if="form.personType === 'C'" :label="$t('listOwner.columns.idCard')">
            <el-input v-model="form.idCard" />
          </el-form-item>

          <el-form-item v-else :label="$t('listOwner.columns.idCard')">
            <el-input v-model="form.idCard" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('common.remark')">
            <el-input v-model="form.remark" />
          </el-form-item>
        </el-col>
      </el-row>

      <div v-for="(item, index) in attrs" :key="index">
        <el-row :gutter="20" v-if="index % 2 === 0">
          <el-col :span="12">
            <el-form-item :label="item.specName">
              <input v-if="item.specType === '2233'" v-model="item.value" :placeholder="item.specHoldplace" class="custom-input" />
              <select v-else-if="item.specType === '3344'" v-model="item.value" class="custom-select">
                <option v-for="val in item.values" :key="val.value" :label="val.valueName" :value="val.value">
                  {{ val.valueName }}
                </option>
              </select>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="index < attrs.length - 1">
            <el-form-item :label="attrs[index + 1].specName">
              <input v-if="attrs[index + 1].specType === '2233'" v-model="attrs[index + 1].value" :placeholder="attrs[index + 1].specHoldplace" class="custom-input" />
              <select v-else-if="attrs[index + 1].specType === '3344'" v-model="attrs[index + 1].value" class="custom-select">
                <option v-for="val in attrs[index + 1].values" :key="val.value" :label="val.valueName" :value="val.value">
                  {{ val.valueName }}
                </option>
              </select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">
        {{ $t("listOwner.buttons.cancel") }}
      </el-button>
      <el-button type="primary" @click="updateOwner">
        {{ $t("listOwner.buttons.save") }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { editOwner, getAttrValue, uploadImage } from "@/api/owner/ownerApi";
import { getAttrSpecList } from "@/api/dev/attrSpecApi";

export default {
  name: "EditOwner",
  data() {
    return {
      visible: false,
      form: {
        ownerId: "",
        name: "",
        link: "",
        address: "",
        sex: "",
        remark: "",
        ownerPhoto: "",
        ownerPhotoUrl: "",
        idCard: "",
        personType: "P",
        personRole: "1",
        concactPerson: "",
        concactLink: "",
      },
      attrs: [],
      personTypes: [
        { value: "P", label: this.$t("listOwner.personType.personal") },
        { value: "C", label: this.$t("listOwner.personType.company") },
      ],
      personRoles: [
        { value: "1", label: this.$t("listOwner.role.owner") },
        { value: "2", label: this.$t("listOwner.role.tenant") },
      ],
      genders: [
        { value: "0", label: this.$t("listOwner.gender.male") },
        { value: "1", label: this.$t("listOwner.gender.female") },
      ],
      rules: {
        name: [{ required: true, message: this.$t("listOwner.placeholders.name"), trigger: "blur" }],
        personType: [{ required: true, message: this.$t("listOwner.placeholders.typeRequired"), trigger: "change" }],
        personRole: [{ required: true, message: this.$t("listOwner.placeholders.roleRequired"), trigger: "change" }],
        link: [{ required: true, message: this.$t("listOwner.placeholders.phoneRequired"), trigger: "blur" }],
        sex: [{ required: true, message: this.$t("listOwner.placeholders.genderRequired"), trigger: "change" }],
      },
      stream: null, // 摄像头视频流
      hasCamera: false, // 是否支持摄像头
    };
  },
  methods: {
    loadImageFromBlob(blob) {
      return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(blob);
        const img = new Image();
        img.onload = () => {
          URL.revokeObjectURL(url);
          resolve(img);
        };
        img.onerror = (e) => {
          URL.revokeObjectURL(url);
          reject(e);
        };
        img.src = url;
      });
    },
    canvasToJpegBlob(canvas, quality) {
      return new Promise((resolve) => {
        canvas.toBlob((blob) => resolve(blob), "image/jpeg", quality);
      });
    },
    scaleDownCanvas(sourceCanvas, ratio) {
      const targetCanvas = document.createElement("canvas");
      targetCanvas.width = Math.max(1, Math.round(sourceCanvas.width * ratio));
      targetCanvas.height = Math.max(1, Math.round(sourceCanvas.height * ratio));
      const ctx = targetCanvas.getContext("2d");
      ctx.drawImage(sourceCanvas, 0, 0, targetCanvas.width, targetCanvas.height);
      return targetCanvas;
    },
    async compressJpegFile(file, { maxBytes = 100 * 1024, maxDimension = 1080 } = {}) {
      if (!file || !(file instanceof Blob)) return file;
      if (file.type === "image/jpeg" && file.size <= maxBytes) return file;

      const img = await this.loadImageFromBlob(file);

      const canvas = document.createElement("canvas");
      const iw = img.naturalWidth || img.width;
      const ih = img.naturalHeight || img.height;
      const scale = Math.min(maxDimension / iw, maxDimension / ih, 1);
      canvas.width = Math.max(1, Math.round(iw * scale));
      canvas.height = Math.max(1, Math.round(ih * scale));

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      let quality = 0.9;
      let blob = await this.canvasToJpegBlob(canvas, quality);

      while (blob && blob.size > maxBytes && quality > 0.15) {
        quality = Math.max(0.15, quality - 0.1);
        blob = await this.canvasToJpegBlob(canvas, quality);
      }

      let workingCanvas = canvas;
      while (blob && blob.size > maxBytes && (workingCanvas.width > 320 || workingCanvas.height > 320)) {
        workingCanvas = this.scaleDownCanvas(workingCanvas, 0.9);
        quality = Math.min(quality, 0.8);
        blob = await this.canvasToJpegBlob(workingCanvas, quality);
        while (blob && blob.size > maxBytes && quality > 0.15) {
          quality = Math.max(0.15, quality - 0.1);
          blob = await this.canvasToJpegBlob(workingCanvas, quality);
        }
      }

      const finalBlob = blob && blob.size ? blob : file;
      const name = typeof file.name === "string" && file.name ? file.name.replace(/\.[^/.]+$/, "") + ".jpg" : "photo.jpg";
      return new File([finalBlob], name, { type: "image/jpeg" });
    },
    // 初始化摄像头
    async startCamera() {
      try {
        // 基础兼容性判断
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          this.$message && this.$message.error("当前浏览器不支持摄像头调用");
          return;
        }

        // 先检测当前设备是否存在摄像头
        if (!navigator.mediaDevices.enumerateDevices) {
          // 某些非常老的浏览器没有 enumerateDevices，只能直接尝试 getUserMedia
          this.$message && this.$message.warning("无法检测摄像头设备，直接尝试打开摄像头");
        } else {
          const devices = await navigator.mediaDevices.enumerateDevices();
          const hasCamera = devices.some((d) => d.kind === "videoinput");

          if (!hasCamera) {
            // this.$message && this.$message.error("未检测到摄像头设备");
            this.hasCamera = false;
            return;
          }
        }

        // 注意：video 在 template 里被 v-if 控制，必须等 DOM 渲染出来再取 ref。
        // 第一次可能因为权限弹窗很慢“刚好没问题”，第二次 getUserMedia 很快就会踩到这里。
        this.hasCamera = true;
        await this.$nextTick();

        // 请求摄像头权限（可根据需求设置前后摄像头）
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" }, // 前置可用 'user'
          audio: false,
        });

        const video = this.$refs.video;
        if (!video) {
          // 理论上不应发生：兜底避免抛 TypeError 被当成“权限/设备问题”。
          console.warn("video ref 未就绪，无法挂载摄像头流");
          return;
        }

        if ("srcObject" in video) {
          video.srcObject = this.stream;
        } else {
          // 旧浏览器兼容
          video.src = window.URL.createObjectURL(this.stream);
        }
        video.play();
      } catch (err) {
        console.error("打开摄像头失败", err);

        // 根据错误类型给更友好的提示
        if (err.name === "NotFoundError" || err.name === "OverconstrainedError") {
          this.$message && this.$message.error("未检测到可用的摄像头");
        } else if (err.name === "NotAllowedError" || err.name === "SecurityError") {
          this.$message && this.$message.error("摄像头权限被拒绝，请在浏览器中开启权限");
        } else {
          this.$message && this.$message.error("打开摄像头失败，请检查设备和权限");
        }
      }
    },
    stopCamera() {
      // 1. 停止所有 track
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
        this.stream = null;
      }

      // 2. 清理 video
      const video = this.$refs.video;
      if (video) {
        if ("srcObject" in video) {
          video.srcObject = null;
        } else {
          video.src = "";
        }
        video.pause && video.pause();
      }
    },
    // 拍照 / 重新拍照
    takePhoto() {
      // 若当前已经有照片：点击“拍照”= 重新拍照（清空旧图 -> 展示预览 -> 重启摄像头）
      console.log(this.form.ownerPhotoUrl);
      if (this.form.ownerPhotoUrl) {
        if (!this.hasCamera) return;

        this.form.ownerPhoto = "";
        this.form.ownerPhotoUrl = "";

        // 允许重复选择同一文件（上传照片后也可再选同一张）
        if (this.$refs.fileInput) this.$refs.fileInput.value = "";

        // 先停再启，避免部分浏览器占用摄像头导致 getUserMedia 失败
        this.stopCamera();
        this.$nextTick(() => this.startCamera());
        return;
      }

      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      if (!video || !canvas) return;

      const vw = video.videoWidth;
      const vh = video.videoHeight;
      if (!vw || !vh) {
        console.warn("无法获取视频分辨率");
        return;
      }

      const maxSize = 1080; // 限制最大宽高

      // 计算等比例缩放比例，保证宽高都不超过 1080
      const scale = Math.min(maxSize / vw, maxSize / vh, 1);

      const targetW = Math.round(vw * scale);
      const targetH = Math.round(vh * scale);

      // 设置 canvas 的内部绘制尺寸（真实图片尺寸）
      canvas.width = targetW;
      canvas.height = targetH;

      const ctx = canvas.getContext("2d");
      // 把当前视频帧画到指定大小
      ctx.drawImage(video, 0, 0, targetW, targetH);

      // 转成 Blob
      canvas.toBlob(
        (blob) => {
          if (!blob) return;
          // 如果 _doUploadImage 需要 File：
          const file = new File([blob], "photo.jpg", { type: "image/jpeg" });
          this.uploadImage({file});
          this.stopCamera(); // 拍照后停止摄像头
        },
        "image/jpeg",
        0.8
      );
    },

    open(owner) {
      this.form = { ...owner, ownerPhotoUrl: owner.faceUrl };
      this.visible = true;
      this.loadAttributes();
      this.$nextTick(async () => {
        await this.startCamera();
      });
    },

    async loadAttributes() {
      try {
        const { data } = await getAttrSpecList({ page: 1, row: 100, tableName: "building_owner_attr" });
        if (data.length == 0) {
          return;
        }
        this.attrs = data.filter((item) => item.specShow === "Y");

        for (const attr of this.attrs) {
          attr.value = "";
          if (attr.specType === "3344") {
            attr.values = await getAttrValue(attr.specCd);
          }

          // 设置已有属性值
          if (this.form.ownerAttrDtos) {
            const attrDto = this.form.ownerAttrDtos.find((dto) => dto.specCd === attr.specCd);
            attr.value = attrDto ? attrDto.value : "";
            attr.attrId = attrDto ? attrDto.attrId : "";
          }
        }
      } catch (error) {
        console.error("Failed to load attributes:", error);
      }
    },

    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error(this.$t("common.jpgOnly"));
      }
      if (!isLt2M) {
        this.$message.error(this.$t("common.sizeLimit"));
      }
      return isJPG && isLt2M;
    },

    async uploadImage({ file }) {
      try {
        const compressedFile = await this.compressJpegFile(file, { maxBytes: 100 * 1024, maxDimension: 1080 });
        const res = await uploadImage({ file: compressedFile });
        this.form.ownerPhoto = res.fileId;
        this.form.ownerPhotoUrl = res.url;
        this.$forceUpdate();
      } catch (error) {
        this.$message.error(this.$t("listOwner.upload.failed"));
      }
    },

    async updateOwner() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;

        try {
          const params = {
            ...this.form,
            attrs: this.attrs.map((attr) => ({
              attrId: attr.attrId,
              specCd: attr.specCd,
              value: attr.value,
            })),
          };

          await editOwner(params);
          this.$message.success(this.$t("common.operationSuccess"));
          this.visible = false;
          this.$emit("success");
        } catch (error) {
          this.$message.error(error);
        }
      });
    },

    resetForm() {
      this.$refs.form.resetFields();
      this.form = {
        ownerId: "",
        name: "",
        link: "",
        address: "",
        sex: "",
        remark: "",
        ownerPhoto: "",
        ownerPhotoUrl: "",
        idCard: "",
        personType: "P",
        personRole: "1",
        concactPerson: "",
        concactLink: "",
      };
      this.attrs = [];
      this.stopCamera();
    },
  },
};
</script>

<style scoped>
.text-center {
  text-align: center;
}

.mt-10 {
  margin-top: 10px;
}

/* 自定义输入框样式，模拟 el-input */
.custom-input {
  width: 100%;
  height: 32px;
  line-height: 32px;
  padding: 0 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  background-color: #fff;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  box-sizing: border-box;
}

.custom-input:focus {
  outline: none;
  border-color: #409eff;
}

.custom-input:hover {
  border-color: #c0c4cc;
}

.custom-input::placeholder {
  color: #c0c4cc;
}

/* 自定义选择框样式，模拟 el-select */
.custom-select {
  width: 100%;
  height: 32px;
  line-height: 32px;
  padding: 0 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  background-color: #fff;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  box-sizing: border-box;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e");
  background-position: right 8px center;
  background-repeat: no-repeat;
  background-size: 16px;
  padding-right: 32px;
}

.custom-select:focus {
  outline: none;
  border-color: #409eff;
}

.custom-select:hover {
  border-color: #c0c4cc;
}

.custom-select option {
  padding: 8px 12px;
  background-color: #fff;
  color: #606266;
}

.custom-select option:hover {
  background-color: #f5f7fa;
}

.avatar-uploader {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}
</style>
